import { render, staticRenderFns } from "./forex-mt4.vue?vue&type=template&id=155ddcb6&scoped=true"
import script from "./forex-mt4.vue?vue&type=script&lang=js"
export * from "./forex-mt4.vue?vue&type=script&lang=js"
import style0 from "./forex-mt4.vue?vue&type=style&index=0&id=155ddcb6&prod&lang=css"
import style1 from "./forex-mt4.vue?vue&type=style&index=1&id=155ddcb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ddcb6",
  null
  
)

export default component.exports